import { useEffect } from "react";
import { useLocation } from "react-router";
export const scrollToTopOfElementRef = (ref) => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (!ref.current)
            return;
        ref.current.scrollTo(0, 0);
    }, [pathname]);
};
